import { c as _c } from "react-compiler-runtime";
import { type Control, type ControllerFieldState, type FieldValues, useFormState } from "react-hook-form";

/**
 * The form layer's error-visibility policy, defined once for every RHF field
 * component: a field's validation error becomes visible after the user touched
 * the field or the form was submitted. When and how validation *runs* (mode,
 * trigger, submit) is the form's concern — fields consume this verdict instead
 * of re-implementing the gate locally.
 *
 * Pass `control` when the field supports usage outside a `FormProvider`;
 * otherwise the surrounding form context is used.
 */
export function useFieldErrorVisibility(fieldState, control) {
  const $ = _c(2);
  let t0;
  if ($[0] !== control) {
    t0 = control ? {
      control
    } : undefined;
    $[0] = control;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    isSubmitted
  } = useFormState(t0);
  return Boolean(fieldState.error?.message && (fieldState.isTouched || isSubmitted));
}